import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";


export default class SameHeightGrid extends React.Component {
    static propTypes = {
        className : PropTypes.string
    };

    render = () => (
        <div className={classnames(this.props.className, "flex-grid flex-grid--same-height")}>
            { this.props.children }
        </div>
    );
}



// WEBPACK FOOTER //
// ./js/mywort/commons/components/same-height-grid/SameHeightGrid.jsx